<template>
    <article class="main-branch">
        <h3 class="blind">지점 선택하기</h3>
        <div class="round-tab" role="tablist">
            <button
                v-for="branch in branchList"
                :key="branch.branchId"
                type="button"
                role="tab"
                class="btn-tab"
                :aria-selected="branch.branchId == selectedBranchId"
                @click="handleBranchSelect(branch.branchId.toString())"
                :ref="setBranchRef(branch.branchId)"
            >
                {{ branch.branchNm }}
            </button>
        </div>
    </article>
</template>

<script setup>
    import { nextTick, ref, toRefs, watch, onMounted } from 'vue';
    import { useRootStore } from '@/stores/modules';
    import { useRoute } from 'vue-router';

    const route = useRoute();
    const rootStore = useRootStore();
    const { getStoreInfo, setSelectedBranchId, updateUrlQuery } = rootStore;
    const { selectedBranchId, branchList } = toRefs(rootStore);

    const branchRefs = ref({});

    const setBranchRef = (branchId) => {
        return (el) => {
            if (el) {
                branchRefs.value[branchId] = el;
            }
        };
    };
    const handleBranchSelect = async (branchId) => setSelectedBranchId(branchId);
    const scrollToBranch = () => {
        const el = branchRefs.value[selectedBranchId.value];
        if (el && el.scrollIntoView) {
            el.scrollIntoView({
                behavior: 'smooth',
                inline: 'center',
                block: 'nearest',
            });
        }
    };

    // URL query로부터 지점 ID를 가져와 설정
    onMounted(() => {
        // URL에서 branch 파라미터 확인
        const branchId = route.query?.branch;
        if (branchId && branchId !== selectedBranchId.value) {
            // URL에 branch 파라미터가 있고 현재 선택된 지점과 다르면 지점 변경
            setSelectedBranchId(branchId);
        } else if (selectedBranchId.value && !route.query?.branch) {
            // URL에 branch 파라미터가 없고 선택된 지점이 있으면 URL 업데이트
            updateUrlQuery(selectedBranchId.value);
        }
    });
    watch(
        selectedBranchId,
        (to) => {
            getStoreInfo(to);
        },
        { immediate: true },
    );
    watch(branchList, async () => {
        await nextTick();
        scrollToBranch();
    });
</script>

<script>
    export default {
        name: 'MainBranch',
    };
</script>
